import lodash from 'lodash'
import moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import DatePicker from '../../../../../../1stlog-ui/src/components/DatePicker'
import Field, {
  useField,
} from '../../../../../../1stlog-ui/src/components/Field'
import DatePresets from './DatePresets'

const Wrapper = styled.div``

const DateSelect = (props) => {
  const { isMixedTransport, isPickup } = props

  const [date, setDate] = useField('date', { asState: true })

  // set date to today if its not set
  useEffect(() => {
    let initDate = moment()
    if (isMixedTransport) {
      initDate = moment().businessAdd(1, 'day')
    }
    // console.log("initDate", { initDate, isMixedTransport })
    if (!date) {
      setTimeout(() => setDate(initDate.toISOString()), 0)
    }
  }, [date, isMixedTransport])

  useEffect(() => {}, [isMixedTransport])

  return (
    <Wrapper className="d-flex">
      <Field
        name="date"
        label={
          i18n.t('pickup_date', 'Abholdatum')
          // isPickup
          //   ? i18n.t('pickup_date', 'Abholdatum')
          //   : i18n.t('delivery_date', 'Zustelldatum')
        }
      >
        <DatePicker
          className="tab_jump_transport_date"
          min={moment().toISOString()}
          autoclose
        />
      </Field>
      <div className="ml-2">
        <Field name="date" label={i18n.t('quick_selection', 'Schnellauswahl')}>
          <DatePresets />
        </Field>
      </div>
    </Wrapper>
  )
}

export default DateSelect
